import type { SearchedRepo } from "@/lib/types";

function repoKey(repo: Pick<SearchedRepo, "owner" | "name">) {
  return `${repo.owner.toLowerCase()}/${repo.name.toLowerCase()}`;
}

export function dedupeSearchedRepos(repos: SearchedRepo[]) {
  const uniqueRepos = new Map<string, SearchedRepo>();

  for (const repo of repos) {
    const key = repoKey(repo);
    if (!uniqueRepos.has(key)) {
      uniqueRepos.set(key, repo);
    }
  }

  return Array.from(uniqueRepos.values());
}
